module.exports = __webpack_public_path__ + "img/bul_feature03_active.4247393c.svg";